export default {
  automatedMessage: {
    id: 'buyback_conversation_automated_message',
    defaultMessage: 'Automated message',
  },
  loadMore: {
    id: 'buyback_conversation_load_more_button',
    defaultMessage: 'Load more',
  },
}
